import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import SurveyAccess from './pages/Survey/SurveyAccess';
import ResetPassword from './pages/auth/ResetPassword';

// If URL path starts with /survey/access/<token>, render the survey access page directly.
const path = window.location.pathname || '';
const surveyMatch = path.match(/^\/survey\/access\/([^\/]+)\/?$/);
const resetMatch = path.match(/^\/reset-password\/([^\/]+)\/?$/);
if (surveyMatch) {
  const token = decodeURIComponent(surveyMatch[1]);
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <SurveyAccess token={token} />
    </React.StrictMode>
  );
} else if (resetMatch) {
  const token = decodeURIComponent(resetMatch[1]);
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ResetPassword token={token} />
    </React.StrictMode>
  );
} else {
  // Mount the App component into the 'root' element defined in index.html
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
  // exit early
}
 
